import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';

import {Grid} from 'react-bootstrap';

import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import DocumentsList from './documents-list';
import Input from 'form/input';
import Spinner from 'spinner';
import {Label, UniversalDateTime, UniversalSearchWrapper, UniversalDateWrapper } from 'components/common';
import {ButtonDefault} from 'components/buttons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Pagination from 'pagination';

import {loadDocumentsPublic, searchPublicDocuments} from 'redux/actions/admin/documents';

const mapStateToProps = (state) => ({
  documents: state.adminDocuments.get('documentsList'),
  isFetching: state.adminDocuments.get('documentsAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (offset) => dispatch(loadDocumentsPublic(25, offset)),
  onSearch: (name, start_date, end_date, offset) => dispatch(searchPublicDocuments(name, start_date, end_date, 20, offset))
});


class Documents extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      start_date: moment("01-01-2018", "MM-DD-YYYY"),
      end_date: moment()
    }

    this.changeSearchName = this.changeSearchName.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  onChangeStartDate(date) {
    this.setState({
      start_date: date
    })
  }

  onChangeEndDate(date) {
    this.setState({
      end_date: date
    })
  }

  componentWillMount() {
    const page = this.props.match.params.page || 1;
    const offset = 25 * (page - 1);
    this.props.onSearch(this.state.name, this.state.start_date, this.state.end_date, offset)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 25 * (page - 1);
      this.props.onSearch(this.state.name, this.state.start_date, this.state.end_date, offset)
    }
  }

  render() {

    if (this.props.documents === undefined) {
      return null;
    }

    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Інфоцентр</Link></li>
          <li><Link to="/infocenter/documents">Нормативно-правова база</Link></li>
        </Breadcrumbs>
        <Wrapper>

          <Grid>
            <h2>Нормативно-правова база</h2>
            <UniversalSearchWrapper onSubmit={(event) => {
              event.preventDefault();
              this.props.onSearch(this.state.name, this.state.start_date, this.state.end_date)
            }}>
              <Input
                block
                placeholder="Введіть назву або номер документа"
                label="Пошук за назвою або номером документа"
                value={this.state.name}
                onChange={this.changeSearchName}
              />

              <UniversalDateWrapper>
              <UniversalDateTime>
                <Label>Початкова дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.start_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeStartDate}
                />
              </UniversalDateTime>
              <UniversalDateTime>
                <Label>Кінцева дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.end_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeEndDate}
                />
              </UniversalDateTime>
            </UniversalDateWrapper>
              <ButtonDefault type="submit" value="Пошук" />
            </UniversalSearchWrapper>
            {this.props.documents.get('results').size > 0 ?
            (
              <div>
                {this.props.isFetching ? (
                  <Spinner />
                ):(
                  <DocumentsList documents={this.props.documents.get('results')}/>
                )}
              </div>
            ):(
              <h4 style={{marginTop: "20px"}}>За даними критеріями пошуку документи не знайдено</h4>
            )}
              <Pagination counts={this.props.documents.get('count')} path={`/infocenter/documents/`} matched={this.props.match.params.page} limits={20} />
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Documents));



// WEBPACK FOOTER //
// ./src/system/information-center/documents/index.js